import React from 'react';
import { Row, Col, Well } from 'react-bootstrap';
import Slider from '@mygooder/react-slick';
import CustomizeYourStayCard from './CustomizeYourStayCard';
import { NextArrow, PrevArrow } from './../../shared/SliderArrows';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { customerJourneyCategories } from './../../../actions';

import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';

import './customizeyourstay.scss';

class CustomizeYourStay extends React.Component {

  constructor(props) {
    super(props);
    this.handleAfterChange = this.handleAfterChange.bind(this);
    this.goToFirstCard = this.goToFirstCard.bind(this);
  }

  handleAfterChange(currentIndex) {

    const sliderCount = this.slider.props.children.length;
    const currentBreakpoint = this.slider.state.breakpoint;
    const currentSlidesToShow = (find(this.slider.props.responsive, ['breakpoint', currentBreakpoint]) || {}).settings.slidesToShow;

    if(sliderCount < currentSlidesToShow) return;

    const minShowIndex = Math.floor(currentSlidesToShow/2);
    let maxShowIndex = (sliderCount - 1) - minShowIndex;
    if(currentSlidesToShow % 2 == 0) maxShowIndex++;
    

    if(currentIndex < minShowIndex) {
      let self = this;
      setTimeout(function(){ 
        self.slider.slickGoTo(minShowIndex); 
      }, 0);
      return;
    }

    if(currentIndex > maxShowIndex) {
      let self = this;
      setTimeout(function(){ 
        self.slider.slickGoTo(maxShowIndex); 
      }, 0);
      return;
    }
  }

  goToFirstCard() {
    if(!this.slider) return;
    const currentBreakpoint = this.slider.state.breakpoint;
    const currentSlidesToShow = (find(this.slider.props.responsive, ['breakpoint', currentBreakpoint]) || {}).settings.slidesToShow;
    const minShowIndex = Math.floor(currentSlidesToShow/2);
    /* This defer prevents Key missing error when using inner slider into component lifecycle... :-| */
    let self = this;
    setTimeout(function(){ 
      if(!!self.slider) self.slider.slickGoTo(minShowIndex); 
    }, 0);
  }

  componentWillMount() {
    this.props.actions.customerJourneyCategories(this.props.token, this.props.currentLanguage, this.props.context);
  }

  componentDidMount() {
    this.goToFirstCard();
  }

  componentWillUpdate(nextProps) {
    if(this.props.categories != nextProps.categories) {
      this.goToFirstCard();
    }
  }

  render() {

    if(!Array.isArray(this.props.categories) || (isEmpty(this.props.categories) && !this.props.loading)) return null;

    const slickSettings = {
      afterChange: this.handleAfterChange,
      swipeToSlide: false,
      infinite: false,
      centerMode: true,
      variableWidth: false,
      prevArrow: <PrevArrow/>,
      nextArrow: <NextArrow/>,
      responsive: [ 
        { breakpoint: 768, settings: { initialSlide: 0, slidesToShow: 1, slidesToScroll: 1, arrows: false } }, 
        { breakpoint: 1024, settings: { initialSlide: 0, slidesToShow: 2, slidesToScroll: 1, arrows: true } }, 
        { breakpoint: 9999, settings: { initialSlide: 0, slidesToShow: 3, slidesToScroll: 1, arrows: true } } 
      ]
    };

    const cards = this.props.categories.map((category, index) => {
      return (<div key={index}><CustomizeYourStayCard title={category.name} buttonLink={`/#/customize/${this.props.context ? `${this.props.context}/${this.props.token}` : this.props.token}/${category.id}`} backgroundImage={category.image}/></div>);
    });

    const emptyCards = [0,1,2,3].map((index) => {
      const dotTitle = <i className="fa fa-ellipsis-h fa-2x"/>;
      return(<div key={index}><CustomizeYourStayCard title={dotTitle} buttonLink={null}/></div>);
    });

    return (
      <Row className="welcome-customizeyourstay-component">
        <Col xs={12}>
          <Well bsSize="large">
            <h3 className="welcome-customizeyourstay-component__title"><strong>{this.props.translate('welcome.customize_your_stay.title')}</strong></h3>
            <p className="welcome-customizeyourstay-component__text">{this.props.translate('welcome.customize_your_stay.text')}</p>

            <br/>

            <Slider ref={c => this.slider = c } {...slickSettings} className="welcome-customizeyourstay-component__slider">
              {cards.length > 0 ? cards : emptyCards}
            </Slider>
          </Well>
        </Col>
      </Row>
    );
  }
}

CustomizeYourStay.displayName = 'PagesWelcomeCustomizeYourStay';
CustomizeYourStay.propTypes = {};
CustomizeYourStay.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      token: state.commons.token,
      context: state.commons.context,
      categories: state.categories.apiData,
      loading: state.categories.loading
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyCategories: bindActionCreators(customerJourneyCategories, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomizeYourStay);


// WEBPACK FOOTER //
// ./components/pages/welcome/CustomizeYourStay.js